<div class="frame-67_168-3038" [class.expandedTopView]="isExpandedView || isFullScreen">
  <div class="frame-112_168-3039">
    <div class="frame-107_168-3040">
      <div class="frame-114_168-3041">
        <div class="arrow-left_170-3729" (click)="assetReviewClosehandle()">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 12.5H1M1 12.5L8 19.5M1 12.5L8 5.5"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="frame-122_168-3044">
          <span class="text-target--2225_168-3045">{{assetReviewStoreDetails?.storeName}}</span>
        </div>
      </div>
      <div class="frame-106_168-3046">
        <div *ngIf="!isNewPage"  class="expand-05_168-3050"   (click)="expandPanel()">
          <svg *ngIf="!isFullScreen"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 9L21 3M21 3H15M21 3V9M9 9L3 3M3 3L3 9M3 3L9 3M9 15L3 21M3 21H9M3 21L3 15M15 15L21 21M21 21V15M21 21H15"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <img height="24" width="24" *ngIf="isFullScreen" src="assets/images/Collapse.png" alt="" srcset="">
        </div>
        <div *ngIf="!isNewPage" class="open-in-new-svgrepo-com_168-3052" (click)="openInNewPage()">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5 2H7C7.55228 2 8 2.44772 8 3C8 3.51284 7.61396 3.93551 7.11662 3.99327L7 4H5C4.48716 4 4.06449 4.38604 4.00673 4.88338L4 5V19C4 19.5128 4.38604 19.9355 4.88338 19.9933L5 20H19C19.5128 20 19.9355 19.614 19.9933 19.1166L20 19V17C20 16.4477 20.4477 16 21 16C21.5128 16 21.9355 16.386 21.9933 16.8834L22 17V19C22 20.5977 20.7511 21.9037 19.1763 21.9949L19 22H5C3.40232 22 2.09634 20.7511 2.00509 19.1763L2 19V5C2 3.40232 3.24892 2.09634 4.82373 2.00509L5 2ZM21 2L21.081 2.003L21.2007 2.02024L21.3121 2.04974L21.4232 2.09367L21.5207 2.146L21.6168 2.21279L21.7071 2.29289L21.8037 2.40469L21.8753 2.51594L21.9063 2.5769L21.9401 2.65835L21.9642 2.73401L21.9931 2.8819L22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V5.414L13.7071 11.7071C13.3466 12.0676 12.7794 12.0953 12.3871 11.7903L12.2929 11.7071C11.9324 11.3466 11.9047 10.7794 12.2097 10.3871L12.2929 10.2929L18.584 4H15C14.4477 4 14 3.55228 14 3C14 2.44772 14.4477 2 15 2H21Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="open-in-new-svgrepo-com_168-3052">
                <!-- download-button.component.html -->
<div class="download-dropdown" (clickOutside)="closeDropdown()" >
  <span class="download-button" [class.dropdownSelected]="dropdownOpen" (click)="toggleDropdown()" matTooltip="Download" matTooltipClass="custom-tooltip" matTooltipPosition="above">
    <div class="icon download-icon" >
      <!-- Your SVG download icon -->
      <svg width="25" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"  >
        <path d="M12.5535 17.0061C12.4114 17.1615 12.2106 17.25 12 17.25C11.7894 17.25 11.5886 17.1615 11.4465 17.0061L7.44649 12.6311C7.16699 12.3254 7.18823 11.851 7.49393 11.5715C7.79964 11.292 8.27403 11.3132 8.55353 11.6189L11.25 14.5682V3.5C11.25 3.08579 11.5858 2.75 12 2.75C12.4142 2.75 12.75 3.08579 12.75 3.5V14.5682L15.4465 11.6189C15.726 11.3132 16.2004 11.292 16.5061 11.5715C16.8118 11.851 16.833 12.3254 16.5535 12.6311L12.5535 17.0061Z" fill="white"/>
        <path d="M3.75 15.5C3.75 15.0858 3.41422 14.75 3 14.75C2.58579 14.75 2.25 15.0858 2.25 15.5V15.5549C2.24998 16.9225 2.24996 18.0248 2.36652 18.8918C2.48754 19.7919 2.74643 20.5497 3.34835 21.1516C3.95027 21.7536 4.70814 22.0125 5.60825 22.1335C6.47522 22.25 7.57754 22.25 8.94513 22.25H15.0549C16.4225 22.25 17.5248 22.25 18.3918 22.1335C19.2919 22.0125 20.0497 21.7536 20.6517 21.1516C21.2536 20.5497 21.5125 19.7919 21.6335 18.8918C21.75 18.0248 21.75 16.9225 21.75 15.5549V15.5C21.75 15.0858 21.4142 14.75 21 14.75C20.5858 14.75 20.25 15.0858 20.25 15.5C20.25 16.9354 20.2484 17.9365 20.1469 18.6919C20.0482 19.4257 19.8678 19.8142 19.591 20.091C19.3142 20.3678 18.9257 20.5482 18.1919 20.6469C17.4365 20.7484 16.4354 20.75 15 20.75H9C7.56459 20.75 6.56347 20.7484 5.80812 20.6469C5.07435 20.5482 4.68577 20.3678 4.40901 20.091C4.13225 19.8142 3.9518 19.4257 3.85315 18.6919C3.75159 17.9365 3.75 16.9354 3.75 15.5Z" fill="white"/>
      </svg>
    </div>
    <div class="chevron" [class.open]="dropdownOpen">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10l5 5 5-5H7z" />
      </svg>
    </div>
  </span>

  <ul class="download-options" *ngIf="dropdownOpen">
    <li class="d-flex" (click)="download('pdf')"><img src="assets/images/book-closed.png" alt=""> PDF</li>
    <li class="d-flex" (click)="download('excel')" ><img src="assets/images/stars-02.png" alt=""> Excel</li>
    <li class="d-flex" (click)="download('csv')"> <img src="assets/images/play-circle.png" alt=""> CSV</li>
  </ul>
</div>

        </div>
      </div>
    </div>
    <div [class.expanded]="isFullScreen" class="frame-108_168-3054">
      <div class="frame-109_168-3055">
        <div class="marker-pin-01_168-3056">
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.00065 8.08366C7.96715 8.08366 8.75065 7.30016 8.75065 6.33366C8.75065 5.36716 7.96715 4.58366 7.00065 4.58366C6.03415 4.58366 5.25065 5.36716 5.25065 6.33366C5.25065 7.30016 6.03415 8.08366 7.00065 8.08366Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.00065 13.3337C9.33398 11.0003 11.6673 8.91099 11.6673 6.33366C11.6673 3.75633 9.57798 1.66699 7.00065 1.66699C4.42332 1.66699 2.33398 3.75633 2.33398 6.33366C2.33398 8.91099 4.66732 11.0003 7.00065 13.3337Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span class="text-1425-main-street--cincinnati--oh-45202_168-3058"
          >{{assetReviewStoreDetails?.address}}</span
        >
      </div>
      <div class="frame-110_168-3059">
        <div class="target-05_168-3060">
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99935 13.3337C10.221 13.3337 12.8327 10.722 12.8327 7.50033C12.8327 4.27866 10.221 1.66699 6.99935 1.66699C3.77769 1.66699 1.16602 4.27866 1.16602 7.50033C1.16602 10.722 3.77769 13.3337 6.99935 13.3337Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.99935 11.0003C8.93235 11.0003 10.4993 9.43332 10.4993 7.50033C10.4993 5.56733 8.93235 4.00033 6.99935 4.00033C5.06635 4.00033 3.49935 5.56733 3.49935 7.50033C3.49935 9.43332 5.06635 11.0003 6.99935 11.0003Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.99935 8.66699C7.64368 8.66699 8.16602 8.14466 8.16602 7.50033C8.16602 6.85599 7.64368 6.33366 6.99935 6.33366C6.35502 6.33366 5.83268 6.85599 5.83268 7.50033C5.83268 8.14466 6.35502 8.66699 6.99935 8.66699Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span class="text-trade-area--downtown-cincinnat_168-3062"
          > {{assetReviewStoreDetails.tradeAreaName}}</span
        >
      </div>
      <div class="frame-111_168-3063">
        <div class="file-07_168-3064">
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.16732 1.82422V4.2337C8.16732 4.5604 8.16732 4.72375 8.2309 4.84853C8.28682 4.95829 8.37606 5.04753 8.48582 5.10345C8.6106 5.16703 8.77395 5.16703 9.10065 5.16703H11.5101M4.66732 9.25033V11.0003M9.33398 8.08366V11.0003M7.00065 6.62533V11.0003M11.6673 6.32679V10.5337C11.6673 11.5138 11.6673 12.0038 11.4766 12.3781C11.3088 12.7074 11.0411 12.9751 10.7118 13.1429C10.3375 13.3337 9.84741 13.3337 8.86732 13.3337H5.13398C4.15389 13.3337 3.66385 13.3337 3.2895 13.1429C2.96022 12.9751 2.6925 12.7074 2.52472 12.3781C2.33398 12.0038 2.33398 11.5138 2.33398 10.5337V4.46699C2.33398 3.4869 2.33398 2.99685 2.52472 2.62251C2.6925 2.29323 2.96022 2.02551 3.2895 1.85773C3.66385 1.66699 4.15389 1.66699 5.13398 1.66699H7.00752C7.43555 1.66699 7.64957 1.66699 7.85097 1.71534C8.02954 1.75821 8.20024 1.82892 8.35682 1.92487C8.53342 2.0331 8.68475 2.18443 8.98742 2.48709L10.8472 4.34689C11.1499 4.64956 11.3012 4.80089 11.4094 4.97749C11.5054 5.13407 11.5761 5.30477 11.619 5.48334C11.6673 5.68474 11.6673 5.89876 11.6673 6.32679Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span class="text-report-date--june-18--2025_168-3066"
          >{{assetReviewStoreDetails?.reportDate}}</span
        >
      </div>
    </div>
  </div>
</div>
